(function () {
    function r(e, n, t) {
        function o(i, f) {
            if (!n[i]) {
                if (!e[i]) {
                    var c = "function" == typeof require && require;if (!f && c) return c(i, !0);if (u) return u(i, !0);var a = new Error("Cannot find module '" + i + "'");throw a.code = "MODULE_NOT_FOUND", a;
                }var p = n[i] = { exports: {} };e[i][0].call(p.exports, function (r) {
                    var n = e[i][1][r];return o(n || r);
                }, p, p.exports, r, e, n, t);
            }return n[i].exports;
        }for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) {
            o(t[i]);
        }return o;
    }return r;
})()({ 1: [function (require, module, exports) {
        (function () {
            'use strict';

            function init() {
                var block = document.querySelector('[data-gpt-opinion-url]');
                if (!block) return;
                var content = block.querySelector('[data-gpt-tags]');
                var tags = JSON.parse(content.dataset.gptTags);
                var sentiments = JSON.parse(content.dataset.gptSentiments);
                var loading = block.querySelector('[data-gpt-loading]');
                var cards = block.querySelector('[data-gpt-cards]');
                var template = block.querySelector('[data-gpt-card-template]');
                var request = null;
                var track = function track(name) {
                    var properties = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                    return window.brxTracking && window.brxTracking.sendAnalyticsEvent(name, Object.assign({
                        hotel_id: Number(block.dataset.hotelId),
                        page_type: window.app && window.app.pageType
                    }, properties));
                };

                var previewShown = false;
                var showPreview = function showPreview() {
                    if (previewShown) return;
                    previewShown = true;
                    track('hotel_gpt_preview_show');
                };

                var retryDelays = [10000, 20000];
                var fetchOpinion = function fetchOpinion() {
                    var attempt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
                    return fetch(block.dataset.gptOpinionUrl, {
                        headers: { 'X-Requested-With': 'XMLHttpRequest' }
                    }).then(function (response) {
                        if (response.ok) return response.json();
                        var error = new Error('Unable to load hotel opinion');
                        error.retryable = response.status >= 500;
                        throw error;
                    }).catch(function (error) {
                        if (error.retryable === false || attempt >= retryDelays.length) throw error;
                        return new Promise(function (resolve) {
                            return setTimeout(resolve, retryDelays[attempt]);
                        }).then(function () {
                            return fetchOpinion(attempt + 1);
                        });
                    });
                };

                var load = function load() {
                    if (request) return request;
                    var startedAt = Date.now();
                    request = fetchOpinion().then(function (data) {
                        var summaries = data.reviewsSummary.map(function (item) {
                            return Object.assign({}, item, {
                                details: Object.assign({}, item.details, {
                                    insights: item.details.insights.filter(function (insight) {
                                        return (insight.text || '').trim();
                                    })
                                })
                            });
                        }).filter(function (item) {
                            return (item.summary || '').trim() || item.details.insights.length;
                        });
                        if (!summaries.length) {
                            track('hotel_gpt_load_result', { result: 'empty', duration_ms: Date.now() - startedAt, topics_count: 0 });
                            block.remove();
                            return false;
                        }
                        summaries.forEach(function (item) {
                            var card = template.content.cloneNode(true);
                            var tag = Object.prototype.hasOwnProperty.call(tags, item.tagKey) ? item.tagKey : 'other';
                            card.querySelector('[data-gpt-tag-title]').textContent = tags[tag];
                            card.querySelector('[data-gpt-tag-icon]').setAttribute('href', '#gpt-tag-' + tag);
                            card.querySelector('[data-gpt-summary]').textContent = item.summary;
                            var topic = card.querySelector('[data-gpt-topic]');
                            if (topic) {
                                if (block.querySelector('[data-gpt-mobile-title]')) {
                                    var header = card.querySelector('.hotel-gpt-opinion__topic-header');
                                    var body = card.querySelector('.hotel-gpt-opinion__topic-body');
                                    var toggle = document.createElement('button');
                                    toggle.type = 'button';
                                    toggle.className = header.className + ' hotel-gpt-opinion__topic-toggle';
                                    while (header.firstChild) {
                                        toggle.appendChild(header.firstChild);
                                    }var expanded = cards.children.length === 0;
                                    toggle.setAttribute('aria-expanded', String(expanded));
                                    body.hidden = !expanded;
                                    toggle.addEventListener('click', function () {
                                        body.hidden = !body.hidden;
                                        toggle.setAttribute('aria-expanded', String(!body.hidden));
                                        if (!body.hidden) track('hotel_gpt_topic_open', { topic: tag });
                                    });
                                    header.replaceWith(toggle);
                                }
                                card.querySelector('[data-gpt-groups]').hidden = item.details.insights.length === 0;
                                item.details.insights.forEach(function (insight) {
                                    var sentiment = ['positive', 'negative'].includes(insight.sentiment) ? insight.sentiment : 'neutral';
                                    var entry = document.createElement('li');
                                    entry.textContent = insight.text;
                                    card.querySelector('[data-gpt-list="' + sentiment + '"]').appendChild(entry);
                                    card.querySelector('[data-gpt-group="' + sentiment + '"]').hidden = false;
                                });
                                cards.appendChild(card);
                                return;
                            }
                            var insights = card.querySelector('[data-gpt-insights]');
                            item.details.insights.forEach(function (insight) {
                                var entry = document.createElement('li');
                                var sentiment = ['positive', 'negative'].includes(insight.sentiment) ? insight.sentiment : 'neutral';
                                entry.className = 'hotel-gpt-opinion__insight hotel-gpt-opinion__insight--' + sentiment;
                                var label = document.createElement('span');
                                label.className = 'hotel-gpt-opinion__sentiment';
                                label.textContent = sentiments[sentiment];
                                var text = document.createElement('span');
                                text.className = 'hotel-gpt-opinion__insight-text';
                                text.textContent = insight.text;
                                entry.appendChild(label);
                                entry.appendChild(text);
                                insights.appendChild(entry);
                            });
                            cards.appendChild(card);
                        });
                        loading.hidden = true;
                        track('hotel_gpt_load_result', { result: 'success', duration_ms: Date.now() - startedAt, topics_count: summaries.length });
                        return true;
                    }).catch(function () {
                        track('hotel_gpt_load_result', { result: 'error', duration_ms: Date.now() - startedAt });
                        block.remove();
                        return false;
                    });
                    return request;
                };

                var openButton = block.querySelector('[data-gpt-open]');
                if (openButton) {
                    block.hidden = true;
                    load().then(function (hasContent) {
                        if (!hasContent) return;
                        block.hidden = false;
                        showPreview();
                    });
                    var opening = false;
                    openButton.addEventListener('click', function () {
                        if (opening) return;
                        opening = true;
                        showPreview();
                        track('hotel_gpt_open_click');
                        window.showPageLoader('hotel-gpt-opinion');
                        load().then(function (hasContent) {
                            if (!hasContent) return;
                            return new Promise(function (resolve) {
                                return window.modal.open({
                                    header: openButton.dataset.gptMobileTitle ? { title: openButton.dataset.gptMobileTitle, theme: window.modal.themes.PRIMARY } : null,
                                    footer: null, type: 'full',
                                    parentCssClass: openButton.dataset.gptMobileTitle ? 'hotel-gpt-opinion-mobile-modal' : 'hotel-reviews-panel-modal',
                                    content: { htmlDetachSelectorId: 'hotelGptOpinionModal' },
                                    onAfterShow: function onAfterShow() {
                                        track('hotel_gpt_open');
                                        resolve();
                                    }
                                });
                            });
                        }).finally(function () {
                            opening = false;
                            window.hidePageLoader('hotel-gpt-opinion');
                        });
                    });
                    return;
                }

                if ('IntersectionObserver' in window || typeof IntersectionObserver !== 'undefined') {
                    var observer = new IntersectionObserver(function (entries) {
                        if (entries.some(function (entry) {
                            return entry.isIntersecting;
                        })) {
                            observer.disconnect();
                            load();
                        }
                    }, { threshold: 0 });
                    observer.observe(block);
                } else {
                    var onScroll = function onScroll() {
                        var rect = block.getBoundingClientRect();
                        if (rect.top < window.innerHeight && rect.bottom > 0) {
                            window.removeEventListener('scroll', onScroll);
                            load();
                        }
                    };
                    window.addEventListener('scroll', onScroll, { passive: true });
                    onScroll();
                }
            }

            if (document.readyState === 'loading') {
                document.addEventListener('DOMContentLoaded', init);
            } else {
                init();
            }
        })();
    }, {}] }, {}, [1]);